// Lib
import { FC, ReactNode, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
// Hooks
import { useAppDispatch, useAppSelector } from "hooks";
// Actions
import { setIsUserSideBarOpen } from "redux/slices/ui";
// Selectors
import { isUserSideBarOpenSelector } from "redux/selectors/ui";
// Types
import { SidebarMenuItemType } from "types/common";
// Icons
import { CollapseIcon } from "icons";
// Components
import { Header } from "./components";
// Styled
import {
  AntDLayout,
  ContentContainer,
  MenuContainer,
  MenuItem,
  Sidebar,
  Wrapper,
} from "./styled";

interface LayoutProps {
  sidebarMenuItems: SidebarMenuItemType[];
  children: ReactNode;
}

export const SIDEBAR_WIDTH_OPEN = 248;
export const SIDEBAR_WIDTH_COLLAPSED = 80;

export const Layout: FC<LayoutProps> = ({ sidebarMenuItems, children }) => {
  const dispatch = useAppDispatch();
  const collapsed = useAppSelector(isUserSideBarOpenSelector);
  const { pathname } = useLocation();

  const handleCollapse = () => {
    dispatch(setIsUserSideBarOpen(!collapsed));
  };

  //scroll to top after change route
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Wrapper>
      <Header />

      <AntDLayout hasSider>
        <Sidebar
          width={SIDEBAR_WIDTH_OPEN}
          collapsible
          trigger={null}
          collapsed={collapsed}
          onCollapse={handleCollapse}
        >
          <MenuContainer mode="inline">
            {sidebarMenuItems.map(({ Icon, label, path, type, list }, i) => {
              if (type === "link") {
                return (
                  <MenuItem
                    icon={<Icon />}
                    key={i}
                    $active={pathname.includes(path)}
                    $collapsed={collapsed}
                  >
                    <NavLink to={path}>{label}</NavLink>
                  </MenuItem>
                );
              } else if (type === "list") {
                return (
                  <MenuContainer.SubMenu
                    key={i}
                    title={label}
                    icon={(<Icon />) as unknown as ReactNode}
                  >
                    {list.map((item, indx) => (
                      <MenuItem
                        key={indx}
                        $submenu
                        $active={pathname.includes(item.path)}
                        $collapsed={collapsed}
                      >
                        <NavLink to={item.path}>{item.label}</NavLink>
                      </MenuItem>
                    ))}
                  </MenuContainer.SubMenu>
                );
              }
            })}
          </MenuContainer>

          <MenuContainer mode="inline" $сollapsebutton>
            <MenuItem
              $сollapsebutton
              icon={<CollapseIcon />}
              $collapsed={collapsed}
              onClick={handleCollapse}
            >
              {!collapsed && "Collapse"}
            </MenuItem>
          </MenuContainer>
        </Sidebar>

        <AntDLayout
          className="site-layout"
          style={{
            marginLeft: collapsed
              ? SIDEBAR_WIDTH_COLLAPSED
              : SIDEBAR_WIDTH_OPEN,
            transition: "margin 0.2s",
          }}
        >
          <ContentContainer>{children}</ContentContainer>
        </AntDLayout>
      </AntDLayout>
    </Wrapper>
  );
};
